import { render, staticRenderFns } from "./FieldCreateForm.vue?vue&type=template&id=51b050a8&"
import script from "./FieldCreateForm.vue?vue&type=script&lang=js&"
export * from "./FieldCreateForm.vue?vue&type=script&lang=js&"
import style0 from "./FieldCreateForm.vue?vue&type=style&index=0&id=51b050a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports